export const resetFilter = () => {
  return {
    type: "RESET_FILTER"
  };
};

export const setFilter = filter => {
  return {
    type: "SET_FILTER",
    filter
  };
};

export const setTagsSuggestions = payload => {
  return {
    type: "FETCH_TAGS_SUGGESTIONS",
    payload
  };
};

export const setUsersSuggestions = payload => {
  return {
    type: "FETCH_USERS_SUGGESTIONS",
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/filter.js